import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const DirectDebitSetupFailed = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Common']);

  return (
    <Modal title={t('DirectDebitSetupFailed.title')}>
      <span>{t('DirectDebitSetupFailed.info')}</span>
      <ModalActions>
        <Button onClick={closeModal}>{t('Common:ok')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default DirectDebitSetupFailed;
